import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var TeamTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(TeamTransformer, _BaseTransformer);
  var _super = _createSuper(TeamTransformer);
  function TeamTransformer() {
    _classCallCheck(this, TeamTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(TeamTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        teamId: data.team_id,
        teamName: data.team_name,
        teamAvatar: data.team_avatar,
        group: data.group,
        teamHandle: data.team_handle,
        email: data.email
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return TeamTransformer;
}(BaseTransformer);